import React, { useEffect, useState, useCallback } from 'react';
import { NavLink, useHistory } from "react-router-dom";
import AlertModal from 'web/components/AlertModal';
import PostedPalletsIcon from "web/assets/svg/PostedPalletsIcon";
import MyOfferIcon from 'web/assets/svg/MyOfferIcon'
import MyInventoriesIcon from 'web/assets/svg/MyInventoriesIcon'
import InventoryNeedSearchIcon from 'web/assets/svg/InventoryNeedSearchIcon'
import {
   loadInventoryBagageInfo, orderBagageInfo
} from 'redux/actions/notification';
import { useDispatch, useSelector } from 'react-redux';

import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  Container,
  IconWrapper,
} from "web/components/PalletsSidebar/palletsSidebarStyled";
import { fetchLanguageContentNew } from 'redux/actions/language';

export default function PalletsSidebar({ activePage, postType, activeSearch, expandedPallet }) {

  let history = useHistory();
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');
  const storedData = useSelector(
    (state) => state.storedData.payload
  );
  let disableFlg =  localStorage.getItem('disableFlg')//storedData?.guestUser
  let accountType = localStorage.getItem('accountType')

  const cardExpiryDetails = useSelector(state => state.authReducer.cardExpiryDetails)

  let expandTab = ''
  if (accountType === "Seller") {
    if (expandedPallet === "panel1") {
      expandTab = 'panel1'
    } else {
      expandTab = 'panel2'
    }

  } if (accountType === "Buyer") {
    if (expandedPallet === "panel1") {
      expandTab = 'panel1'
    } else {
      if (!expandedPallet) {
        if (activePage === "PostInventory") {
          expandTab = 'panel1'
        } else {
          expandTab = 'panel2'
        }
      } else {
        expandTab = 'panel1'
      }
    }
  }
  if (accountType === "Both" || accountType === "Reseller") {
    if (expandedPallet === "panel1") {
      expandTab = 'panel1'
    } else {
      if (!expandedPallet) {
        if (activePage === "PostInventory") {
          expandTab = 'panel1'
        } else {
          expandTab = 'panel2'
        }
      } else {
        expandTab = 'panel2'
      }
    }
  }
  if (expandedPallet === null || expandedPallet === undefined || expandedPallet === "sideBar") {
    expandTab = ''
  }
  const [expanded, setExpanded] = React.useState(expandTab);

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const toggleModal = () => setModal(!modal);

  // const [notificationResponse, setNotificationResponse] = useState({
  //   postLoad: [],
  //   inventory: [],
  //   notification: [],
  //   network: [],
  //   order: [],
  // });
  const [loadInventoryResponse, setLoadInventoryResponse] = useState();

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()

  useEffect(() => {
    if (languageContentNew?.SideBar_Page) setPageLanguageContents(languageContentNew.SideBar_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  useEffect(() => {
  }, [])

  const fetchMyAPI = useCallback(async () => {
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/sign-in');
      toggleModal();
    } else {
      let response = await dispatch(loadInventoryBagageInfo(token));
      if (response.status === "SUCCESS") {
        setLoadInventoryResponse(response.payload)
        // orderBagageInfoApi()
      } else {
        if (response.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
        }
      }
    }
  }, []);

  // const [orderResponse, setOrderResponse] = useState();
  // const orderBagageInfoApi = async () => {
  //   if (token === null) {
  //     setModalContent('Please Sign In again.');
  //     setModalLink('/sign-in');
  //     toggleModal();
  //   } else {
  //     let response = await dispatch(orderBagageInfo(token));

  //     if (response.status === "SUCCESS") {
  //       setOrderResponse(response.payload)
  //     } else {
  //       if (response.message === "Unauthorized (Invalid token)") {
  //         history.push('/sign-in')
  //       } else {
  //         setModalContent(response.message);
  //         setModalLink('');
  //         toggleModal();
  //       }
  //     }
  //   }
  // }
  localStorage.setItem('titleInput', '')
  useEffect(() => {
    fetchMyAPI()
  }, [fetchMyAPI]);

  // const preventDefault = (event) => event.preventDefault();

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleNeedLinkClick = event => {
    let obj = {
      type: "PostLoad",
      activePage: "PostLoad",
      expanded: expanded
    }
    dispatch({ type: 'POST_LOAD_URL', payload: obj })
    localStorage.setItem("titleInput", "");
  };
  const handleInventoryLinkClick = event => {
    let obj = {
      type: "PostInventory",
      activePage: "PostInventory",
      expanded: expanded
    }
    dispatch({ type: 'POST_INVENTORY_URL', payload: obj })
    localStorage.setItem("titleInput", "");
  };
  const handleLoadNeedLinkClick = event => {

    let paginationObj = {
      selectedPage: 1,
    }
    dispatch({ type: 'BIDS_PAGINATION', payload: paginationObj })
    let obj = {
      postType: "PostLoad",
      type: "postedNeeds",
      activePage: 'PostLoad',
      expanded: expanded
    }
    dispatch({ type: 'CREATED_NEEDS', payload: obj })
    localStorage.setItem("titleInput", "");
  };
  const handleLoadInventoryLinkClick = event => {
    let paginationObj = {
      selectedPage: 1,
    }
    dispatch({ type: 'BIDS_PAGINATION', payload: paginationObj })
    let obj = {
      postType: "PostInventory",
      type: "palletOffers",
      activePage: 'PostInventory',
      expanded: expanded
    }
    dispatch({ type: 'CREATED_INVENTORY', payload: obj })
    localStorage.setItem("titleInput", "");
  };
  const handleBidsPalletNeedsLinkClick = event => {
    let obj = {
      postType: "PostLoad",
      type: "bidsPalletNeeds",
      activePage: 'PostLoad',
      expanded: expanded
    }
    dispatch({ type: 'BID_NEEDS', payload: obj })
    localStorage.setItem("titleInput", "");
  };
  const handleBidsPalletInventoryLinkClick = event => {
    let obj = {
      postType: "PostInventory",
      type: "bidsPalletOffers",
      activePage: 'PostInventory',
      expanded: expanded
    }
    dispatch({ type: 'BIDS_INVENTORY', payload: obj })
    localStorage.setItem("titleInput", "");
  };
  return (
    <Container className={((!cardExpiryDetails.subscriptionCardExpired)) ? 'sidebar-pallets' : 'sidebar-pallets search-event'}>
      {accountType !== 'Seller' && <Accordion
        disabled={accountType === 'Seller' ? true : false}
        expanded={expanded === "panel1" || expanded === "Both"}
        onChange={handleChange("panel1")}
        className="buy-pallets"
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <h2>{pageLanguageContents?.Buy_Pallet[0]?.Buy}</h2>
        </AccordionSummary>
        <AccordionDetails className="detail-section">
          <NavLink
            exact
            to={{
              pathname: "/nearby-inventory",
            }}
            className="pallets-link"
            activeClassName={postType === "searchInvSideBar" ? 'main-navDark-activeTab' : "main-nav-active"}
          >

            <IconWrapper>
              <InventoryNeedSearchIcon />
              <p>Search for Inventory</p>
            </IconWrapper>
          </NavLink>

          {(!disableFlg || disableFlg === 'false') && <NavLink
            exact
            to={{
              pathname: "/post-my-pallet-needs",
              // search: "?type=PostLoad&activePage=PostLoad&expanded=" + expanded,
            }}
            className="pallets-link"
            activeClassName={!postType && activePage === "PostLoad" ? 'main-navDark-activeTab' : "main-nav-active"}
            onClick={handleNeedLinkClick}
          >

            <IconWrapper>
              <MyInventoriesIcon />
              <p>{pageLanguageContents?.Buy_Pallet[1]?.Post_Load}</p>
            </IconWrapper>
          </NavLink>}
          {(!disableFlg || disableFlg === 'false') && <NavLink
            exact
            to={{
              pathname: "/my-posted-pallet-needs",
              // search: "?postType=PostLoad&type=postedNeeds&activePage=PostLoad&expanded=" + expanded,
            }}
            className="pallets-link"
            activeClassName={postType === "postedNeeds" && activePage === "PostLoad" ? 'main-navDark-activeTab' : "main-nav-active"}
            onClick={handleLoadNeedLinkClick}
          >
            {/* {loadInventoryResponse && loadInventoryResponse.loadCount !== 0 && (
              <p className="myPostedInventoriesNotification">
                {loadInventoryResponse && loadInventoryResponse.loadCount}
              </p>
            )} */}
            <IconWrapper>
              <PostedPalletsIcon />
              <p>{pageLanguageContents?.Buy_Pallet[2]?.BuyPost_Needs}</p>
            </IconWrapper>
          </NavLink>}
          <NavLink
            exact
            to={{
              pathname: "/view-my-offers-on-pallet-inventory",
              // search: "?postType=PostInventory&type=bidsPalletOffers&activePage=PostInventory&expanded=" + expanded,
            }}
            className="pallets-link"
            activeClassName={postType === "bidsPalletOffers" && activePage === "PostInventory" ? 'main-navDark-activeTab' : "main-nav-active"}
            onClick={handleBidsPalletInventoryLinkClick}
          >
            {/* {loadInventoryResponse &&
              loadInventoryResponse.inventoryWithOfferCount !== 0 && (
                <p className="myPostedInventoriesNotification">
                  {loadInventoryResponse &&
                    loadInventoryResponse.inventoryWithOfferCount}
                </p>
              )} */}
            <IconWrapper>
              <MyOfferIcon />
              <p>
                {pageLanguageContents?.Buy_Pallet[3]?.Buy_Bid}
              </p>
            </IconWrapper>
          </NavLink>
        </AccordionDetails>
      </Accordion>}
      {accountType !== 'Buyer' && (!disableFlg || disableFlg === 'false') && <Accordion
        disabled={accountType === 'Buyer' ? true : false}
        expanded={expanded === "panel2" || expanded === "Both"}
        onChange={handleChange("panel2")}
        className="sell-pallets"
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <h2>{pageLanguageContents?.Sell_Pallet[0]?.Sell}</h2>
        </AccordionSummary>
        <AccordionDetails className="detail-section">
          <NavLink
            exact
            to={{
              pathname: "/nearby-needs",
            }}
            className="pallets-link"
            activeClassName={postType === "searchNeedSideBar" ? 'main-nav-activeTab' : "main-nav-active"}
          >
            <IconWrapper>
              <InventoryNeedSearchIcon />
              <p>Search for Need</p>
            </IconWrapper>
          </NavLink>

          <NavLink
            exact
            to={{
              pathname: "/post-my-pallet-inventory",
              // search: "?type=PostInventory&activePage=PostInventory&expanded=" + expanded,
            }}
            className="pallets-link"
            activeClassName={!postType && activePage === "PostInventory" ? 'main-nav-activeTab' : "main-nav-active"}
            onClick={handleInventoryLinkClick}
          >

            <IconWrapper>
              <MyInventoriesIcon />
              <p>{pageLanguageContents?.Sell_Pallet[1]?.Post_Inventory}</p>
            </IconWrapper>
          </NavLink>

          <NavLink
            exact
            to={{
              pathname: "/my-posted-pallet-inventory",
              // search: "?postType=PostInventory&type=palletOffers&activePage=PostInventory&expanded=" + expanded,
            }}
            className="pallets-link"
            activeClassName={postType === "palletOffers" && activePage === "PostInventory" ? 'main-nav-activeTab' : "main-nav-active"}
            onClick={handleLoadInventoryLinkClick}
          >
            {/* {loadInventoryResponse &&
              loadInventoryResponse.inventoryCount !== 0 && (
                <p className="myPostedInventoriesNotification">
                  {loadInventoryResponse &&
                    loadInventoryResponse.inventoryCount}
                </p>
              )} */}
            <IconWrapper>
              <PostedPalletsIcon />
              <p>{pageLanguageContents?.Sell_Pallet[3]?.SellPost_Needs}</p>
            </IconWrapper>
          </NavLink>
          <NavLink
            exact
            to={{
              pathname: "/view-my-bids-on-pallet-needs",
              // search: "?postType=PostLoad&type=bidsPalletNeeds&activePage=PostLoad&expanded=" + expanded,
            }}
            className="pallets-link"
            activeClassName={postType === "bidsPalletNeeds" && activePage === "PostLoad" ? 'main-nav-activeTab' : "main-nav-active"}
            onClick={handleBidsPalletNeedsLinkClick}
          >
            {/* {loadInventoryResponse &&
              loadInventoryResponse.loadWithOfferCount !== 0 && (
                <p className="myPostedInventoriesNotification">
                  {loadInventoryResponse &&
                    loadInventoryResponse.loadWithOfferCount}
                </p>
              )} */}
            <IconWrapper>
              <MyOfferIcon />

              <p>{pageLanguageContents?.Sell_Pallet[2]?.Sell_Bid}</p>
            </IconWrapper>
          </NavLink>
        </AccordionDetails>
      </Accordion>}
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=""
        content={modalContent}
        link={modalLink}
      />
    </Container>
  );
}
